import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useState, useEffect } from 'react';

const COLORS = ["#783BFF", "#7FB1BA", "#01085A"];

export default function TotalStatus({ noteStatus, setOpenTotalModal, openTotalModal, setOpenWeeklyModal, openWeeklyModal, openDailyModal, setOpenDailyModal, doctor_name, access_token }) {
  const [pieData, setPieData] = useState(null);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    if (noteStatus !== null) {
      setTotal(noteStatus.total);

      if (access_token) {
        setPieData(
          [
            { name: "Ready to Record", value: noteStatus.record },
            { name: "Review", value: noteStatus.review },
            { name: "Locked", value: noteStatus.locked }
          ]
        )
      } else {
        setPieData(
          [
            { name: "Ready to Record", value: noteStatus.record },
            { name: "Review", value: noteStatus.review }
          ]
        )
      }
    }

  }, [openTotalModal, openWeeklyModal, openDailyModal])

  const customLegend = (value, entry) => {
    const { value: chartVal } = entry.payload;
    if (total !== 0) {
      return `${value}: ${chartVal} - ${((chartVal / total) * 100).toFixed(2)}%`;
    } else {
      return `${value}: ${chartVal}`;
    }
  }

  const handleWeeklyClick = () => {
    setOpenWeeklyModal(true);
    setOpenTotalModal(false);
    setOpenDailyModal(false);
  }
  
  const handleDailyClick = () => {
    setOpenDailyModal(true);
    setOpenTotalModal(false);
    setOpenWeeklyModal(false);
  }

  const closeTotalModal = () => {
    setOpenTotalModal(false);
  }

  return (
    <div className='fixed left-[28%] top-[28%] w-[50%] flex flex-col items-center justify-center bg-light-purple p-4 rounded-md shadow-md z-10'>
      <button onClick={handleDailyClick}>Show Daily</button>
      <button onClick={handleWeeklyClick}>Show This Week</button>
      <h2 className='text-[26px]'>Historical Note Status for {doctor_name}</h2>
      <h3 className='text-[22px]'>Integrated?: {access_token ? "Yes" : "No"}</h3>
      <button className='absolute right-[20px] top-[10px] hover:text-ktx-navy font-bold text-[26px]' onClick={closeTotalModal}>×</button>

      <div className='relative w-full h-full z-10'>
        <ResponsiveContainer width={"96%"} height={400}>
          <PieChart>
            <Pie
              data={pieData}
              cx={"42%"}
              cy={"40%"}
              labelLine={false}
              outerRadius={160}
              fill="#8884d8"
              dataKey="value"
            >
              {pieData !== null && pieData.map((_, i) => (
                <Cell key={`cell-${i}`} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend layout="vertical" align="right" iconType="circle" iconSize={10} verticalAlign='middle' formatter={customLegend} />
          </PieChart>
        </ResponsiveContainer>

      </div>
    </div>
  )
}